export default "__VITE_ASSET__a1a96c29__"